forms-tasks-memos-save
  form.form(action="{ opts.action }" method="{ opts.method }" onSubmit="{ this.onSubmit }")
    .row
      .col-12
        inputs-hidden(tag-scope="{ this.tagScope }.inputs.method")
        inputs-hidden(tag-scope="{ this.tagScope }.inputs.authenticity_token")
        inputs-hidden(tag-scope="{ this.tagScope }.inputs.index")
        inputs-hidden(tag-scope="{ this.tagScope }.inputs.task_id")
        inputs-textfield(tag-scope="{ this.tagScope }.inputs.value")
        inputs-submit(tag-scope="{ this.tagScope }.inputs.submit")
  script(type="typescript").
    this.mixin('forms.tasks.memos.save');
